"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundItemTypeEnum = exports.RefundTypeEnum = void 0;
var RefundTypeEnum;
(function (RefundTypeEnum) {
    RefundTypeEnum["LEAVE_BALANCE"] = "leave_balance";
    RefundTypeEnum["REDUCE_BALANCE"] = "reduce_balance";
    RefundTypeEnum["FAILED_PAYMENT"] = "failed_payment";
})(RefundTypeEnum = exports.RefundTypeEnum || (exports.RefundTypeEnum = {}));
var RefundItemTypeEnum;
(function (RefundItemTypeEnum) {
    RefundItemTypeEnum["LINE_ITEM"] = "lineItem";
    RefundItemTypeEnum["FEE"] = "fee";
})(RefundItemTypeEnum = exports.RefundItemTypeEnum || (exports.RefundItemTypeEnum = {}));
//# sourceMappingURL=refund.enums.js.map